import axios from 'axios';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import Button from '@mui/material/Button';

import React, { useState } from 'react';

import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useAuth } from '@src/contexts/authContext';

const url = `${process.env.REACT_APP_API_URL}`;

export default function AddAchievement({ openModal, setOpenModal, fetchData }) {
  const { auth } = useAuth();
  const { userId } = useParams();
  const [getAchievement, setGetAchievement] = useState([]);

  const handleAchievement = () => {
    const formData = {
      item: getAchievement.item,
      achievement: getAchievement.achievement,
    };

    axios
      .post(`${url}/admin/achievements/${userId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${auth.idToken}`,
        },
      })
      .then((response) => {
        console.log('Achievement updated successfully:', response);
        setGetAchievement({ ...getAchievement });
        fetchData();
        toast.success('Achievement updated successfully', {
          position: 'top-center',
          autoClose: 2000,
        });
      })
      .catch((error) => {
        console.log(error.message);
        toast.error('The type of achievement is required!', {
          position: 'top-center',
          autoClose: 2000,
        });
      });
  };

  const [selectedFile, setSelectedFile] = useState(null);

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file.name);
      setGetAchievement((prevInput) => ({
        ...prevInput,
        achievement: file,
      }));
    }
  };
  return (
    <Dialog
      maxWidth='sm'
      fullWidth
      open={openModal}
      onClose={() => setOpenModal(false)}
    >
      <DialogTitle>Add new achievement</DialogTitle>
      <br />
      <DialogContent>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          <TextField
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '6px',
              },
              width: '100%',
            }}
            value={getAchievement?.item || ''}
            onChange={(e) =>
              setGetAchievement({
                ...getAchievement,
                item: e.target.value,
              })
            }
            placeholder='e.g. Certificate of Completion'
            variant='outlined'
          />
          <input
            type='file'
            id='achievement'
            accept='image/jpeg, image/png, image/webp, image/svg+xml, application/pdf'
            onChange={handleFile}
            className='text-md'
            style={{ marginTop: 8 }}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ textTransform: 'none' }}
          onClick={() => setOpenModal(false)}
          color='secondary'
        >
          Cancel
        </Button>
        <Button
          sx={{ textTransform: 'none' }}
          onClick={() => {
            handleAchievement();
            setOpenModal(false);
          }}
          color='primary'
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
}
